export default __webpack_public_path__ + "assets/f59a22.svg";